import {
  SEED_APPROVED_STAFF_LEAVE,
  SEED_APPROVED_STAFF_LEAVE_SUCCESS,
  SEED_APPROVED_STAFF_LEAVE_FAIL,
  STAFF_HOLIDAY_CALENDAR_LIST,
  STAFF_HOLIDAY_CALENDAR_LIST_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_LIST_FAIL,
  STAFF_HOLIDAY_CALENDAR_DATA,
  STAFF_HOLIDAY_CALENDAR_DATA_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_DATA_FAIL,
  STAFF_HOLIDAY_CALENDAR_CREATE,
  STAFF_HOLIDAY_CALENDAR_CREATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_CREATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_UPDATE,
  STAFF_HOLIDAY_CALENDAR_UPDATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_UPDATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_DELETE,
  STAFF_HOLIDAY_CALENDAR_DELETE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_DELETE_FAIL,
  STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS,
  STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DATA,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_FAIL,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_SUCCESS,
  STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_FAIL,
  CALENDAR_NON_WORKING_DAY_LIST,
  CALENDAR_NON_WORKING_DAY_LIST_SUCCESS,
  CALENDAR_NON_WORKING_DAY_LIST_FAIL,
  CALENDAR_NON_WORKING_DAY_DATA,
  CALENDAR_NON_WORKING_DAY_DATA_SUCCESS,
  CALENDAR_NON_WORKING_DAY_DATA_FAIL,
  CALENDAR_NON_WORKING_DAY_CREATE,
  CALENDAR_NON_WORKING_DAY_CREATE_SUCCESS,
  CALENDAR_NON_WORKING_DAY_CREATE_FAIL,
  CALENDAR_NON_WORKING_DAY_UPDATE,
  CALENDAR_NON_WORKING_DAY_UPDATE_SUCCESS,
  CALENDAR_NON_WORKING_DAY_UPDATE_FAIL,
  CALENDAR_NON_WORKING_DAY_DELETE,
  CALENDAR_NON_WORKING_DAY_DELETE_SUCCESS,
  CALENDAR_NON_WORKING_DAY_DELETE_FAIL,
  STAFF_LEAVE_CREATE_REQUEST,
  STAFF_LEAVE_CREATE_REQUEST_SUCCESS,
  STAFF_LEAVE_CREATE_REQUEST_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
  STAFF_LEAVE_DECISION_APPROVE,
  STAFF_LEAVE_DECISION_APPROVE_SUCCESS,
  STAFF_LEAVE_DECISION_APPROVE_FAIL,
  STAFF_LEAVE_DECISION_DECLINE,
  STAFF_LEAVE_DECISION_DECLINE_SUCCESS,
  STAFF_LEAVE_DECISION_DECLINE_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_FAIL,
  STAFF_LEAVE_DECISION_DATA,
  STAFF_LEAVE_DECISION_DATA_SUCCESS,
  STAFF_LEAVE_DECISION_DATA_FAIL,
  STAFF_LEAVE_DECISION_LIST_MY_OPEN,
  STAFF_LEAVE_DECISION_LIST_MY_OPEN_SUCCESS,
  STAFF_LEAVE_DECISION_LIST_MY_OPEN_FAIL,
  STAFF_LEAVE_DECISION_LIST,
  STAFF_LEAVE_DECISION_LIST_SUCCESS,
  STAFF_LEAVE_DECISION_LIST_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
  OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_FAIL,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_SUCCESS,
  STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_LIST,
  STAFF_LEAVE_RESTRICTION_PERIOD_LIST_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_LIST_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_DATA,
  STAFF_LEAVE_RESTRICTION_PERIOD_DATA_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_DATA_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_CREATE,
  STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE,
  STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_FAIL,
  STAFF_LEAVE_RESTRICTION_PERIOD_DELETE,
  STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_SUCCESS,
  STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_FAIL,
} from "./actionType";

//STAFF_HOLIDAY_CALENDAR_LIST
export const staffHolidayCalendarList = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_LIST,
    payload,
  };
};

export const staffHolidayCalendarListSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_LIST_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarListFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_LIST_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_payload
export const staffHolidayCalendarData = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_DATA,
    payload,
  };
};

export const staffHolidayCalendarpayloadSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_DATA_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarpayloadFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_DATA_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_CREATE
export const staffHolidayCalendarCreate = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_CREATE,
    payload,
  };
};

export const staffHolidayCalendarCreateSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_CREATE_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarCreateFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_CREATE_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_UPDATE
export const staffHolidayCalendarUpdate = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_UPDATE,
    payload,
  };
};

export const staffHolidayCalendarUpdateSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_UPDATE_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarUpdateFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_UPDATE_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_DELETE
export const staffHolidayCalendarDelete = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_DELETE,
    payload,
  };
};

export const staffHolidayCalendarDeleteSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_DELETE_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarDeleteFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_DELETE_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS
export const staffHolidayCalendarGeneratePeriods = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS,
    payload,
  };
};

export const staffHolidayCalendarGeneratePeriodsSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarGeneratePeriodsFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_GENERATE_PERIODS_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_PERIOD_LIST
export const staffHolidayCalendarPeriodList = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
    payload,
  };
};

export const staffHolidayCalendarPeriodListSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarPeriodListFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
    payload,
  };
};

// STAFF_HOLIDAY_CALENDAR_PERIOD_DATA,
export const staffHolidayCalendarPeriodData = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_DATA,
    payload,
  };
};

export const staffHolidayCalendarPeriodDataSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarPeriodDataFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_DATA_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE
export const staffHolidayCalendarPeriodCreate = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE,
    payload,
  };
};

export const staffHolidayCalendarPeriodCreateSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarPeriodCreateFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_CREATE_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE
export const staffHolidayCalendarPeriodUpdate = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE,
    payload,
  };
};

export const staffHolidayCalendarPeriodUpdateSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarPeriodUpdateFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_UPDATE_FAIL,
    payload,
  };
};

//STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE
export const staffHolidayCalendarPeriodDelete = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE,
    payload,
  };
};

export const staffHolidayCalendarPeriodDeleteSuccess = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_SUCCESS,
    payload,
  };
};

export const staffHolidayCalendarPeriodDeleteFail = (payload) => {
  return {
    type: STAFF_HOLIDAY_CALENDAR_PERIOD_DELETE_FAIL,
    payload,
  };
};

//CALENDAR_NON_WORKING_DAY_LIST
export const calendarNonWorkingDayList = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_LIST,
    payload,
  };
};

export const calendarNonWorkingDayListSuccess = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_LIST_SUCCESS,
    payload,
  };
};

export const calendarNonWorkingDayListFail = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_LIST_FAIL,
    payload,
  };
};

//CALENDAR_NON_WORKING_DAY_DATA
export const calendarNonWorkingDayData = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_DATA,
    payload,
  };
};

export const calendarNonWorkingDayDataSuccess = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_DATA_SUCCESS,
    payload,
  };
};

export const calendarNonWorkingDayDataFail = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_DATA_FAIL,
    payload,
  };
};

//CALENDAR_NON_WORKING_DAY_CREATE
export const calendarNonWorkingDayCreate = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_CREATE,
    payload,
  };
};

export const calendarNonWorkingDayCreateSuccess = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_CREATE_SUCCESS,
    payload,
  };
};

export const calendarNonWorkingDayCreateFail = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_CREATE_FAIL,
    payload,
  };
};

//CALENDAR_NON_WORKING_DAY_UPDATE
export const calendarNonWorkingDayUpdate = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_UPDATE,
    payload,
  };
};

export const calendarNonWorkingDayUpdateSuccess = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_UPDATE_SUCCESS,
    payload,
  };
};

export const calendarNonWorkingDayUpdateFail = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_UPDATE_FAIL,
    payload,
  };
};

//CALENDAR_NON_WORKING_DAY_DELETE
export const calendarNonWorkingDayDelete = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_DELETE,
    payload,
  };
};

export const calendarNonWorkingDayDeleteSuccess = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_DELETE_SUCCESS,
    payload,
  };
};

export const calendarNonWorkingDayDeleteFail = (payload) => {
  return {
    type: CALENDAR_NON_WORKING_DAY_DELETE_FAIL,
    payload,
  };
};

//STAFF_LEAVE_CREATE_REQUEST
export const createStaffLeaveRequest = (payload) => {
  return {
    type: STAFF_LEAVE_CREATE_REQUEST,
    payload,
  };
};

export const createStaffLeaveRequestSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_CREATE_REQUEST_SUCCESS,
    payload,
  };
};

export const createStaffLeaveRequestFail = (payload) => {
  return {
    type: STAFF_LEAVE_CREATE_REQUEST_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT
export const staffToStaffHolidayCalendarPeriodListCurrent = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListCurrentSuccess = (
  payload
) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListCurrentFail = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE
export const staffToStaffHolidayCalendarPeriodListFuture = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListFutureSuccess = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListFutureFail = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST
export const staffToStaffHolidayCalendarPeriodListPast = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListPastSuccess = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListPastFail = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST
export const staffToStaffHolidayCalendarPeriodList = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListSuccess = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListFail = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
    payload,
  };
};

//STAFF_LEAVE_DECISION_APPROVE
export const staffLeaveDecisionApprove = (payload, token) => {
  return {
    type: STAFF_LEAVE_DECISION_APPROVE,
    payload,
    token
  };
};

export const staffLeaveDecisionApproveSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_APPROVE_SUCCESS,
    payload,
  };
};

export const staffLeaveDecisionApproveFail = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_APPROVE_FAIL,
    payload,
  };
};

//STAFF_LEAVE_DECISION_DECLINE
export const staffLeaveDecisionDecline = (payload, token) => {
  return {
    type: STAFF_LEAVE_DECISION_DECLINE,
    payload,
    token
  };
};

export const staffLeaveDecisionDeclineSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_DECLINE_SUCCESS,
    payload,
  };
};

export const staffLeaveDecisionDeclineFail = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_DECLINE_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS
export const staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembers = (
  payload
) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersSuccess =
  (payload) => {
    return {
      type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_SUCCESS,
      payload,
    };
  };

export const staffToStaffHolidayCalendarPeriodListCurrentMyTeamMembersFail = (
  payload
) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_TEAM_MEMBERS_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY
export const staffToStaffHolidayCalendarPeriodListCurrentMy = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListCurrentMySuccess = (
  payload
) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_SUCCESS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListCurrentMyFail = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_MY_FAIL,
    payload,
  };
};

//STAFF_LEAVE_DECISION_DATA
export const staffLeaveDecisionData = (payload, token) => {
  return {
    type: STAFF_LEAVE_DECISION_DATA,
    payload,
    token
  };
};

export const staffLeaveDecisionDataSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_DATA_SUCCESS,
    payload,
  };
};

export const staffLeaveDecisionDataFail = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_DATA_FAIL,
    payload,
  };
};

//STAFF_LEAVE_DECISION_LIST_MY_OPEN
export const staffLeaveDecisionListMyOpen = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_LIST_MY_OPEN,
    payload,
  };
};

export const staffLeaveDecisionListMyOpenSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_LIST_MY_OPEN_SUCCESS,
    payload,
  };
};

export const staffLeaveDecisionListMyOpenFail = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_LIST_MY_OPEN_FAIL,
    payload,
  };
};

//STAFF_LEAVE_DECISION_LIST
export const staffLeaveDecisionList = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_LIST,
    payload,
  };
};

export const staffLeaveDecisionListSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_LIST_SUCCESS,
    payload,
  };
};

export const staffLeaveDecisionListFail = (payload) => {
  return {
    type: STAFF_LEAVE_DECISION_LIST_FAIL,
    payload,
  };
};

//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT
export const overviewStaffToStaffHolidayCalendarPeriodListCurrent = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListCurrentSuccess = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_SUCCESS,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListCurrentFail = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_CURRENT_FAIL,
    payload,
  };
};

//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE
export const overviewStaffToStaffHolidayCalendarPeriodListFuture = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListFutureSuccess = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_SUCCESS,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListFutureFail = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FUTURE_FAIL,
    payload,
  };
};

//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST
export const overviewStaffToStaffHolidayCalendarPeriodListPast = (payload) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListPastSuccess = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_SUCCESS,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListPastFail = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_PAST_FAIL,
    payload,
  };
};

//OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST
export const overviewStaffToStaffHolidayCalendarPeriodList = (payload) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListSuccess = (
  payload
) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_SUCCESS,
    payload,
  };
};

export const overviewStaffToStaffHolidayCalendarPeriodListFail = (payload) => {
  return {
    type: OVERVIEW_STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS
export const staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembers = (
  payload
) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersSuccess =
  (payload) => {
    return {
      type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_SUCCESS,
      payload,
    };
  };

export const staffToStaffHolidayCalendarPeriodListOpenMyAndMyTeamMembersFail = (
  payload
) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_LIST_OPEN_MY_AND_MY_TEAM_MEMBERS_FAIL,
    payload,
  };
};

//STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH
export const staffToStaffHolidayCalendarPeriodSearch = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodSearchSuccess = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_SUCCESS,
    payload,
  };
};

export const staffToStaffHolidayCalendarPeriodSearchFail = (payload) => {
  return {
    type: STAFF_TO_STAFF_HOLIDAY_CALENDAR_PERIOD_SEARCH_FAIL,
    payload,
  };
};

//STAFF_LEAVE_RESTRICTION_PERIOD_LIST
export const staffLeaveRestrictionPeriodList = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_LIST,
    payload,
  };
};

export const staffLeaveRestrictionPeriodListSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_LIST_SUCCESS,
    payload,
  };
};

export const staffLeaveRestrictionPeriodListFail = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_LIST_FAIL,
    payload,
  };
};

//STAFF_LEAVE_RESTRICTION_PERIOD_DATA
export const staffLeaveRestrictionPeriodData = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_DATA,
    payload,
  };
};

export const staffLeaveRestrictionPeriodDataSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_DATA_SUCCESS,
    payload,
  };
};

export const staffLeaveRestrictionPeriodDataFail = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_DATA_FAIL,
    payload,
  };
};

//STAFF_LEAVE_RESTRICTION_PERIOD_CREATE
export const staffLeaveRestrictionPeriodCreate = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_CREATE,
    payload,
  };
};

export const staffLeaveRestrictionPeriodCreateSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_SUCCESS,
    payload,
  };
};

export const staffLeaveRestrictionPeriodCreateFail = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_CREATE_FAIL,
    payload,
  };
};

//STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE
export const staffLeaveRestrictionPeriodUpdate = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE,
    payload,
  };
};

export const staffLeaveRestrictionPeriodUpdateSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_SUCCESS,
    payload,
  };
};

export const staffLeaveRestrictionPeriodUpdateFail = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_UPDATE_FAIL,
    payload,
  };
};

//STAFF_LEAVE_RESTRICTION_PERIOD_DELETE
export const staffLeaveRestrictionPeriodDelete = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_DELETE,
    payload,
  };
};

export const staffLeaveRestrictionPeriodDeleteSuccess = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_SUCCESS,
    payload,
  };
};

export const staffLeaveRestrictionPeriodDeleteFail = (payload) => {
  return {
    type: STAFF_LEAVE_RESTRICTION_PERIOD_DELETE_FAIL,
    payload,
  };
};

//SEED_APPROVED_STAFF_LEAVE - Task 24476
export const seedApprovedStaffLeave = (payload) => {
  return {
    type: SEED_APPROVED_STAFF_LEAVE,
    payload,
  };
};

export const seedApprovedStaffLeaveSuccess = (payload) => {
  return {
    type: SEED_APPROVED_STAFF_LEAVE_SUCCESS,
    payload,
  };
};

export const seedApprovedStaffLeaveFail = (payload) => {
  return {
    type: SEED_APPROVED_STAFF_LEAVE_FAIL,
    payload,
  };
};
